module.exports = __webpack_public_path__ + "static/media/ninePin.1f2d652e.svg";